import './NavTabContainer.scss';
import React, { PropsWithChildren, ReactNode } from 'react';

export const NavTabContainer = ({ children }: PropsWithChildren): ReactNode => (
  <div className="bp-nav-tab-container">
    {children}
  </div>
);
